import type { Member } from './Member'

/**
 * Provides member's info for dropdown menus.
 */
export function formatMemberOption(member: Member) {
  return `${member.displayName} (email: ${member.email}, id: ${member.user.publicId})`
}
